import { Plugins } from '@leverege/plugin'
import FieldFactory from './fields/FieldFactory.js'
import PluginSetup from './PluginSetup.js'
import * as fields from './fields/index.js'

export function init( plugins = Plugins ) {
  PluginSetup.install( plugins )
}

export function parse( fields, context ) {
  return FieldFactory.create( fields, { ...context, fields } )
}

export {
  fields,
  PluginSetup,
  FieldFactory,
}

export default {
  init,
  parse,
  fields,
  PluginSetup,
  FieldFactory,
}
